// extracted by mini-css-extract-plugin
module.exports = {"page":"_404-module--page--hlapt","message":"_404-module--message--2zMfa","illustration":"_404-module--illustration--2uzJK","link":"_404-module--link--1IgzW"};